import type React from 'react';

export const getVideoIdFromUrl = (pathName: string) => {
  return pathName.split('/')[2];
};
// scrolls to the element with the id
export const scrollToElement = (elementId: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

// Function to seek the media (video or audio) to a specific time
export const onClickTimestamp = (t: number) => {
  // Try to find a video element
  let mediaElement = document.getElementById(
    'video-element',
  ) as HTMLMediaElement;

  // If no video element is found, try to find an audio element
  if (!mediaElement) {
    mediaElement = document.getElementById('audio-element') as HTMLMediaElement;
  }

  if (!mediaElement) return;
  if (!Number.isFinite(t)) return;

  mediaElement.currentTime = t;
  mediaElement.play();
};

export const isMobileDevice = (): boolean => {
  return window.innerWidth < 768;
};

export const handleEnterKeyPress =
  (f: Function) => (e: React.KeyboardEvent) => {
    // Ignore if any modifier key is pressed
    if (e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) return;
    if (e.key === 'Enter') {
      f?.();
    }
  };

export const getLetterAvatar = (name: string) => {
  let letter = '';
  if (name) {
    letter = name?.charAt(0);
    letter = letter?.toUpperCase();
  }
  return letter;
};
